import { http } from '@services/http'

import { generateImage } from './generateShapeImage'
import { roundToTwoDecimals } from './numberWithSpaces'

export const fetchShapeItemsWithPrices = async ({ tabType, modalService }) => {
	try {
		const tabTypeParam = tabType ? `TabType=${tabType}&` : ''
		const url = `api/items/items-and-price-of-shapes?${tabTypeParam}PageSize=1000&Skip=0&ModalService=${modalService}`
		const { data } = await http.get(url)

		return data.map((item) => ({
			...item,
			image: generateImage(item.itemCode),
		}))
	} catch (error) {
		console.log(error)
	}
}

export const fetchSales = async ({ queryKey }) => {
	const [
		_,
		page,
		cardName,
		docNum,
		startDate,
		endDate,
		slpName,
		department,
		api,
		pageSize,
	] = queryKey
	try {
		const url = `${api}?cardName=${cardName}&docNum=${docNum}&slpName=${slpName}&department=${department}&startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		const formattedData = data.data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}
export const fetchSalesFinished = async ({ queryKey }) => {
	const [
		_,
		page,
		cardName,
		docNum,
		startDate,
		endDate,
		slpName,
		department,
		api,
		pageSize,
	] = queryKey
	try {
		const url = `${api}?cardName=${cardName}&docNum=${docNum}&slpName=${slpName}&department=${department}&startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		const formattedData = data.data?.map((dataItem, index) => {
			return {
				...dataItem,
				documentLines: dataItem.documentLines.map((item) => {
					return {
						...item,
						u_PlannedQuantity: item.u_Kvmetr,
					}
				}),
			}
		})
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchSalesRequestAdmin = async ({ queryKey }) => {
	const [
		_,
		page,
		cardName,
		docNum,
		startDate,
		endDate,
		slpName,
		cancelStatus,
		pageSize,
	] = queryKey
	try {
		const url = `api/sales/sotuv-buyurtmasi?cardName=${cardName}&docNum=${docNum}&slpName=${slpName}&isCancelRequested=${cancelStatus}&startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		const formattedData = data.data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchDocRate = async () => {
	try {
		const url = `	api/currency/get-currency-rate`
		const { data } = await http.get(url)

		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchSalesOrder = async ({ queryKey }) => {
	const [
		_,
		page,
		cardName,
		docNum,
		startDate,
		endDate,
		slpName,
		cancelStatus,
		delStatus,
		pageSize,
		department,
		orderStatus,
	] = queryKey
	try {
		const url = `api/sales/sotuv-buyurtmasi?cardName=${cardName}&docNum=${docNum}&slpName=${slpName}&delStatus=${delStatus}&department=${department}&isCancelRequested=${cancelStatus}&orderStatus=${orderStatus}&startDate=${startDate}&endDate=${endDate}&skip=${page}&inventoryStatus=O&pageSize=${pageSize}`
		const { data } = await http.get(url)
		const formattedData = data.data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}
export const fetchSalesOrderWithDocEntry = async ({ queryKey }) => {
	const [_, docEntry] = queryKey
	try {
		const url = `api/sales/sotuv-buyurtmasi?docEntry=${docEntry}`
		const { data } = await http.get(url)
		const formattedData = data.data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}
export const fetchShippedSales = async ({ queryKey }) => {
	const [_, docEntry] = queryKey
	try {
		const url = `api/sales/ortib-yuborilgan?baseEntry=${docEntry}&skip=0&pageSize=100`
		const { data } = await http.get(url)
		const formattedData = data?.data?.map((item, index) => ({
			key: index,
			...item,
			documentLines: item.documentLines.map((line, lineIndex) => ({
				docEntry: item.docEntry,
				...line,
			})),
		}))
		console.log(formattedData)
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchSalesOrderByDocEntry = async ({ queryKey }) => {
	const [_, docEntry] = queryKey
	if (!docEntry) return
	try {
		const url = `api/sales/sotuv-buyurtmasi?docEntry=${docEntry}`
		const { data } = await http.get(url)
		const formattedData = data?.data[0]
		const mappedDocLines = {
			...formattedData,
			documentLines: formattedData?.documentLines.map((item) => ({
				...item,
				koef: item.u_Coefficient,
				ugpCode: item.ugpCode,
				u_PlannedQuantity: item.u_PlannedQuantity,
				shippedQuantity: Number(
					+item.u_PlannedQuantity -
						+roundToTwoDecimals(
							item.openQty /
								(((item.u_Width * item.u_Height) / 1000000) *
									1),
						),
				),
				shippedQuantityKvm: item.quantity - item.openQty,
				oneItemKvm: ((item.u_Width * item.u_Height) / 1000000) * 1,
				openQuantitySon: roundToTwoDecimals(
					item.openQty /
						(((item.u_Width * item.u_Height) / 1000000) * 1),
				),
			})),
		}

		return mappedDocLines
	} catch (error) {
		console.log(error)
	}
}

export const fetchSalesOrderIgnored = async ({ queryKey }) => {
	const [
		_,
		page,
		cardName,
		docNum,
		startDate,
		endDate,
		slpName,
		cancelStatus,
		department,
	] = queryKey
	try {
		const url = `api/sales/sotuv-buyurtmasi?cardName=${cardName}&docNum=${docNum}&slpName=${slpName}&department=${department}&isCancelRequested=${cancelStatus}&startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=10&inventoryStatus=O`
		const { data } = await http.get(url)
		const formattedData = data.data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchSalesWithPageSize = async ({ queryKey }) => {
	const [
		_,
		page,
		cardName,
		docNum,
		startDate,
		endDate,
		slpName,
		department,
		api,
	] = queryKey
	try {
		const url = `${api}?cardName=${cardName}&docNum=${docNum}&slpName=${slpName}&department=${department}&startDate=${startDate}&endDate=${endDate}&pageToken=${page}&pageSize=10`
		const { data } = await http.get(url)
		const formattedData = data.data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchPurchases = async ({ queryKey }) => {
	const [
		_,
		page,
		cardName,
		docNum,
		startDate,
		endDate,
		slpName,
		api,
		furaNum,
		invoiceNum,
	] = queryKey
	try {
		const url = `${api}?cardName=${cardName}&docNum=${docNum}&slpName=${slpName}&startDate=${startDate}&endDate=${endDate}&invoiceNum=${invoiceNum}&furaNum=${furaNum}&pageToken=${page}`
		const { data } = await http.get(url)
		const formattedData = data.data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchPurchasesWithPageSize = async ({ queryKey }) => {
	const [
		_,
		page,
		cardName,
		docNum,
		startDate,
		endDate,
		slpName,
		delStatus,
		api,
		furaNum,
		invoiceNum,
	] = queryKey
	try {
		const url = `${api}?cardName=${cardName}&docNum=${docNum}&slpName=${slpName}&invoiceNum=${invoiceNum}&furaNum=${furaNum}&delStatus=${delStatus}&startDate=${startDate}&endDate=${endDate}&pageToken=${page}&pageSize=10`
		const { data } = await http.get(url)
		const formattedData = data.data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}
export const fetchPurchasesIncoming = async ({ queryKey }) => {
	const [_, purchaseOrderDocEntry] = queryKey //DelStatusBoyicha yozilishi kerak
	try {
		const url = `api/purchase/yetib-kelgan-buyurtmalar?baseEntry=${purchaseOrderDocEntry}`
		const { data } = await http.get(url)
		const formattedData = data?.data?.map((item, index) => ({
			key: index,
			...item,
			documentLines: item.documentLines.map((line, lineIndex) => ({
				docEntry: item.docEntry,
				...line,
			})),
		}))
		return formattedData
	} catch (error) {
		console.log(error)
	}
}
export const fetchLandedCostsByPurchaseInvoice = async ({ queryKey }) => {
	const [_, docEntry] = queryKey
	try {
		const url = `api/landedcosts?purchaseInvoiceDocEntry=${docEntry}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchOutgoingPayments = async ({ queryKey }) => {
	const [_, page, cardCode, docNum, startDate, endDate] = queryKey
	try {
		const url = `api/vendorpayments?cardCode=${cardCode}&docNum=${docNum}&startDate=${startDate}&endDate=${endDate}&pageToken=${page}&pageSize=10`
		const { data } = await http.get(url)
		return data.data
	} catch (error) {
		console.log(error)
	}
}

export const fetchDebtors = async ({ queryKey }) => {
	const [_, page, cardName, docNum, slpCode, pageSize] = queryKey
	try {
		const url = `api/businesspartners/debetors?cardName=${cardName}&docNum=${docNum ?? ''}&slpCode=${slpCode ?? ''}&pageSize=${pageSize}&pageToken=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchClients = async ({ queryKey }) => {
	const [_, page, cardName, cardType, phoneNumber, address] = queryKey
	try {
		const url = `api/businesspartners/mijozlar?cardName=${cardName}&cardType=${cardType}&phoneNumber=${phoneNumber}&address=${address}&pageSize=10&pageToken=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchClientsSelect = async ({ queryKey }) => {
	const [_, cardName, pageSize, api] = queryKey
	try {
		const url = `${api}?cardName=${cardName}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchItemsSelect = async ({ queryKey }) => {
	const [_, itemName, category, api] = queryKey
	try {
		const url = `${api}?itemName=${itemName}&category=${category}&pageToken=0&pageSize=1000`
		const { data } = await http.get(url)
		return data.data
	} catch (error) {
		console.log(error)
	}
}

export const fetchItemsOnly = async ({ queryKey }) => {
	const [_, itemName, category, page, pageSize] = queryKey
	try {
		const url = `api/items/get-items?itemName=${itemName}&category=${category}&categories=100,103,104,105&pageSize=${pageSize}&pageToken=${page}`
		const { data } = await http.get(url)
		return data.data
	} catch (error) {
		console.log(error)
	}
}
export const fetchAllItemsOnly = async () => {
	try {
		const url = `api/items/get-items?categories=100,103,104,105&pageSize=5000&pageToken=0`
		const { data } = await http.get(url)
		return data.data
	} catch (error) {
		console.log(error)
	}
}

export const fetchSuppliersSelect = async ({ queryKey }) => {
	const [_, cardName, pageSize, api] = queryKey
	try {
		const url = `${api}?cardName=${cardName}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		return data.data
	} catch (error) {
		console.log(error)
	}
}

export const fetchDdsArticle = async ({ queryKey }) => {
	try {
		const url = `api/incomingpayments/dds-articles`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchCashAccounts = async ({ queryKey }) => {
	try {
		const url = `api/cashaccounts`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchIncomingPayments = async ({ queryKey }) => {
	const [_, page, cardName, docNum, startDate, endDate, acctName] = queryKey
	try {
		const url = `api/incomingpayments?cardName=${cardName}&docNum=${docNum}&acctName=${acctName}&startDate=${startDate}&endDate=${endDate}&pageSize=10&pageToken=${page}`
		const { data } = await http.get(url)
		return data.data
	} catch (error) {
		console.log(error)
	}
}

export const fetchWarehouse = async () => {
	try {
		const { data } = await http.get(`api/warehouses`)
		const mappedItems = data.map((item) => ({
			code: item.warehouseCode,
			name: item.warehouseName,
		}))
		return mappedItems
	} catch (err) {
		console.log(err)
	}
}

export const fetchWarehouseSelect = async () => {
	try {
		const { data } = await http.get(`api/warehouses`)

		return data
	} catch (err) {
		console.log(err)
	}
}

export const fetchReports = async ({ queryKey }) => {
	const [_, page, itemName] = queryKey

	try {
		const { data } = await http.get(
			`api/items/inventory-items?itemName=${itemName}&categories=103&pageToken=${page}&pageSize=30`,
		)
		const formattedData = data.data.map((item, index) => ({
			key: index,
			itemCode: item.itemCode,
			itemName: item.itemName,
			onHandSum: item.onHandSum,
			inventoryItemWhs: item.inventoryItemWhs.map((wItem, wIndex) => ({
				key: wIndex + 1,
				warehouseName: wItem.whsName,
				onHand: wItem.onHand,
				onOrder: wItem.onOrder,
				available: wItem.available,
				isCommited: wItem.isCommited,
			})),
		}))
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchReportsWithWhs = async ({ queryKey }) => {
	const [_, page, itemName, whsCode] = queryKey

	try {
		const { data } = await http.get(
			`api/items/items-by-warehouse?whsCode=${whsCode}&categories=103&itemName=${itemName}&pageSize=30&skip=${page}`,
		)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchBalance = async ({ queryKey }) => {
	const [_, uzsCash, usdCash] = queryKey

	try {
		const { data } = await http.get(
			`api/cashaccounts?uzsAccount=${uzsCash}&usdAccount=${usdCash}`,
		)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchItems = async ({ queryKey }) => {
	const [_, itemName, itemCode, page] = queryKey
	try {
		const url = `api/items/inventory-items?itemName=${itemName}&itemCode=${itemCode}&pageToken=${page}&pageSize=10`
		const { data } = await http.get(url)
		return data.data
	} catch (error) {
		console.log(error)
	}
}

export const fetchItemsGroups = async () => {
	try {
		const url = `api/items/item-groups`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}
export const fetchItemsServicesGroups = async () => {
	try {
		const url = `api/items/service-groups/values`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}
export const fetchItemsModalServices = async () => {
	try {
		const url = `api/items/modal-service/values`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchRoles = async () => {
	try {
		const url = `api/users/roles`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchDepartments = async () => {
	try {
		const url = `api/departments`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchSalesPerson = async () => {
	try {
		const { data } = await http.get(`api/users/sales-employees`)
		return data
	} catch (err) {
		console.log(err)
	}
}

export const fetchItemsGlass = async ({ queryKey }) => {
	const [_, itemName, itemCode, page] = queryKey
	try {
		const url = `api/items/inventory-items?itemName=${itemName}&itemCode=${itemCode}&categories=103&pageToken=${page}&pageSize=10`
		const { data } = await http.get(url)
		return data.data
	} catch (error) {
		console.log(error)
	}
}

export const fetchSuppliers = async ({ queryKey }) => {
	const [_, cardName, phoneNumber, page] = queryKey
	try {
		const url = `api/businesspartners/yetkazib-beruvchilar?cardName=${cardName}&phoneNumber=${phoneNumber}&pageToken=${page}&pageSize=10`
		const { data } = await http.get(url)
		return data.data
	} catch (error) {
		console.log(error)
	}
}

export const fetchSeeSales = async ({ queryKey }) => {
	const [_, page, cardCode, docNum, startDate, endDate] = queryKey

	try {
		let url = ''

		url = `api/businesspartners/get-bp-documents?cardCode=${cardCode}&docNum=${docNum}&startDate=${startDate}&endDate=${endDate}&pageSize=1000&skip=${page}`
		const { data } = await http.get(url)

		const formattedData = data

		const hasMore = formattedData.length === 10 ? true : false
		return formattedData
	} catch (error) {
		console.log(error)
	}
}
export const fetchSeeSalesWithSlp = async ({ queryKey }) => {
	const [_, page, cardCode, docNum, startDate, endDate, slpCode] = queryKey

	try {
		let url = ''

		url = `api/businesspartners/get-bp-documents?cardCode=${cardCode}&slpCode=${slpCode}&docNum=${docNum}&startDate=${startDate}&endDate=${endDate}&pageSize=1000&skip=${page}`
		const { data } = await http.get(url)

		const formattedData = data

		const hasMore = formattedData.length === 10 ? true : false
		return formattedData
	} catch (error) {
		console.log(error)
	}
}
export const fetchOneSeeSales = async ({ queryKey }) => {
	const [_, cardCode, docNum, isFetchData] = queryKey
	if (!isFetchData) return
	try {
		let url = ''

		url = `api/businesspartners/get-bp-documents?cardCode=${cardCode}&docNum=${docNum}&pageSize=100&skip=0`
		const { data } = await http.get(url)

		const formattedData = data

		const hasMore = formattedData.length === 10 ? true : false
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchCostTypes = async () => {
	try {
		const { data } = await http.get('api/landedcosts/cost-types')
		return data
	} catch (error) {
		console.error(error)
	}
}

export const fetchLandedCosts = async () => {
	try {
		const { data } = await http.get('api/landedcosts')
		return data
	} catch (error) {
		console.error(error)
	}
}

export const fetchStockTransfers = async ({ queryKey }) => {
	const [_, page] = queryKey
	try {
		const url = `api/stocktransfers?pageSize=20&skip=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchItemsStockTransfers = async () => {
	try {
		const url = `api/stocktransfers/items`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchExpectedPayments = async ({ queryKey }) => {
	const [_, page, cardName, startDate, endDate,department] = queryKey
	try {
		const url = `api/sales/sales-order-open-amounts?department=${department}&cardName=${cardName}&startDate=${startDate}&endDate=${endDate}&pageSize=10&skip=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchSeeSalesView = async ({ queryKey }) => {
	const [_, docEntry] = queryKey
	try {
		const url = `api/sales/sotuv-buyurtmasi?docEntry=${docEntry}`
		const { data } = await http.get(url)
		const formattedData = data.data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchPackageServicesNoPagination = async () => {
	try {
		const url = `api/packageofservices`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchUoMGroups = async () => {
	try {
		const { data } = await http.get(`api/items/uom-groups`)

		return data
	} catch (err) {
		console.log(err)
	}
}

export const fetchProductionOrders = async ({ queryKey }) => {
	const [_, page, pageSize, startDate, endDate, department] = queryKey
	try {
		const url = `api/pots/get-pots?department=${department}&startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		const formattedData = data
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchPriorities = async () => {
	try {
		const { data } = await http.get(`api/pots/get-priority-values`)

		return data
	} catch (err) {
		console.log(err)
	}
}

export const fetchSeriesBarcode = async ({ queryKey }) => {
	const [_, docEntry] = queryKey
	if (!docEntry) return
	try {
		const url = `api/pots/get-pots-lines?salesOrderDocEntry=${docEntry}&skip=0&pageSize=1000`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchProductionWorkers = async ({ queryKey }) => {
	const [
		_,
		page,
		pageSize,
		startDate,
		endDate,
		docNum,
		isStarted,
		isReady,
		isReadyForNextStage,
		department,
		service,
		isBroken
	] = queryKey
	try {
		console.log('docNum', docNum)
		const url = `api/pots/get-pots-lines?isProductionAllowed=Yes&isBroken=${isBroken || ""}&salesOrderDocNum=${docNum}&isStarted=${isStarted}&isReady=${isReady}&isReadyForNextStage=${isReadyForNextStage}&department=${department}&service=${service}&startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		const formattedData = data.map((dataItem, index) => {
			return {
				...dataItem,
				key: `${dataItem.service}-${dataItem.serialNumber}`,
			}
		})
		return formattedData
	} catch (error) {
		console.log(error)
	}
}
export const fetchProductionWorkersInProcess = async ({ queryKey }) => {
	const [_, department, service] = queryKey

	try {
		const url = `api/pots/get-pots-lines?isProductionAllowed=Yes&isStarted=Yes&isReady=No&department=${department}&service=${service}&skip=0&pageSize=1000`
		const { data } = await http.get(url)

		// ✅ Step 1: format base data
		const formattedData = data.map((dataItem) => ({
			...dataItem,
			key: `${dataItem.service}-${dataItem.serialNumber}`,
			timer: Number(dataItem?.timer) * 60 || 30, // convert to seconds
			u_Timer: Number(dataItem?.timer) * 60 || 30,
		}))

		// ✅ Step 2: group by salesOrderDocNum
		const groupedData = Object.values(
			formattedData.reduce((acc, item) => {
				const orderNum = item.salesOrderDocNum

				if (!acc[orderNum]) {
					acc[orderNum] = {
						salesOrderDocNum: orderNum,
						salesOrderDocNumPrefix: item.salesOrderDocNumPrefix,
						salesOrderDocEntry: item.salesOrderDocEntry,
						dueDate: item.dueDate,
						department: item.department,
						departmentName: item.departmentName,
						service: item.service,
						description: item.description,
						itemName: item.itemName,
						width: item.width,
						hight: item.hight,
						lines: [],
						startTime: item.startTime,
						timer: 0,
						u_Timer: 0,
					}
				}

				// Push the line
				acc[orderNum].lines.push(item)

				// ✅ Calculate the smallest startTime
				if (
					item.startTime &&
					(!acc[orderNum].startTime ||
						item.startTime < acc[orderNum].startTime)
				) {
					acc[orderNum].startTime = item.startTime
				}

				// ✅ Sum timers
				acc[orderNum].timer += item.timer || 0
				acc[orderNum].u_Timer += item.timer || 0

				return acc
			}, {}),
		)

		const addedTimer = groupedData.reduce(
			(item, acc) => {
				item.timer += acc.timer
				item.u_Timer += acc.u_Timer
				return item
			},
			{ timer: 0, u_Timer: 0 },
		)

		const smallestStartTime = groupedData.reduce(
			(item, acc) => {
				if (
					acc.startTime &&
					(!item.startTime || acc.startTime < item.startTime)
				) {
					item.startTime = acc.startTime
				}
				return item
			},
			{ startTime: null },
		)

		const finalData = [
			{
				...addedTimer,
				...smallestStartTime,
				lines: groupedData,
			},
		]

		console.log('groupedData', groupedData)

		return groupedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchProductionWorkersNotDelivered = async ({ queryKey }) => {
	const [_, department, service] = queryKey
	try {
		const url = `api/pots/get-pots-lines?isDelivery=true&department=${department}&skip=0&pageSize=100`
		const { data } = await http.get(url)
		const formattedData = data.map((dataItem, index) => {
			return {
				...dataItem,
				key: `${dataItem.service}-${dataItem.serialNumber}`,
				timer: Number(dataItem?.timer) * 60 || 30,
				u_Timer: Number(dataItem?.timer) * 60 || 30,
			}
		})
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchProductionWorkersAdmin = async ({ queryKey }) => {
	const [_key, params] = queryKey
	const {
		page,
		pageSize,
		startDate,
		endDate,
		docNum,
		isReadyForNextStage,
		department,
		service,
		defaultStatus,
		isCompleted,
		isOnProcess,
		notStarted,
		isOverDue,
		notReadyForNextStage,
		hasToDoneToday,
		isBroken,
	} = params

	try {
		const today = new Date().toISOString().split('T')[0]
		const statusQuery = new URLSearchParams()

		const setStatus = (obj) => {
			Object.entries(obj).forEach(([key, val]) => {
				if (val !== undefined && val !== null) statusQuery.set(key, val)
			})
		}

		if (defaultStatus)
			setStatus({
				startDate: '',
				isStarted: '',
				isReady: '',
				isReadyForNextStage: '',
													isBroken: '',

			})
		else if (isCompleted)
			setStatus({
				isStarted: 'Yes',
				isReady: 'Yes',
				isReadyForNextStage: '',
									isBroken: '',

			})
			else if (isBroken)
				setStatus({
					isBroken: 'Y',
					isStarted: '',
					isReady: '',
					isReadyForNextStage: '',
				})
		else if (isOnProcess)
			setStatus({
				isStarted: 'Yes',
				isReady: 'No',
				isReadyForNextStage: 'Yes',
													isBroken: '',

			})
		else if (notStarted)
			setStatus({
				startDate: today,
				endDate,
				isStarted: 'No',
				isReady: 'No',
				isReadyForNextStage: 'Yes',
													isBroken: '',

			})
		else if (isOverDue)
			setStatus({
				startDate: '',
				endDate: today,
				isStarted: 'No',
				isReady: 'No',
				isReadyForNextStage: 'Yes',
													isBroken: '',

			})
		else if (hasToDoneToday)
			setStatus({
				startDate: today,
				endDate: today,
				isStarted: 'No',
				isReady: 'No',
				isReadyForNextStage: 'Yes',
													isBroken: '',

			})
		else if (notReadyForNextStage)
			setStatus({
				startDate,
				endDate,
				isReadyForNextStage: 'No',
													isBroken: '',

			})

		// Combine all query params
		const query = new URLSearchParams({
			salesOrderDocNum: docNum ?? '',
			department: department ?? '',
			service: service ?? '',
			isReadyForNextStage: isReadyForNextStage ?? '',
			startDate: startDate ?? '',
			endDate: endDate ?? '',
			skip: page ?? 0,
			pageSize: pageSize ?? 20,
			isProductionAllowed: 'Yes',
			isBroken: isBroken ?? '',
		})

		// Merge status query into main query
		statusQuery.forEach((value, key) => query.set(key, value))

		const url = `api/pots/get-pots-lines?${query.toString()}`
		const { data } = await http.get(url)

		return data
	} catch (error) {
		console.error('fetchProductionWorkersAdmin error:', error)
		throw error
	}
}

//
export const fetchProductionWorkersDone = async ({ queryKey }) => {
	const [_, page, pageSize, startDate, endDate, docNum, department, service] =
		queryKey
	try {
		const url = `api/pots/get-pots-lines?salesOrderDocNum=${docNum}&department=${department}&service=${service}&startDate=${startDate}&endDate=${endDate}&isStarted=Yes&isReady=Yes&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		const formattedData = data.map((dataItem, index) => {
			return {
				...dataItem,
				key: `${dataItem.service}-${dataItem.serialNumber}`,
			}
		})
		return formattedData
	} catch (error) {
		console.log(error)
	}
}

export const fetchProductionInSalesModal = async ({ queryKey }) => {
	const [
		_,
		page,
		pageSize,
		salesOrderDocEntry,
		isStarted,
		isReady,
		isReadyForNextStage,
		startDate,
		endDate,
		isBroken
	] = queryKey
	try {
		const url = `api/pots/get-pots-lines?salesOrderDocEntry=${salesOrderDocEntry}&isStarted=${isStarted}&isReady=${isReady}&isBroken=${isBroken || ""}&isReadyForNextStage=${isReadyForNextStage}&startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		const formattedData = data.map((dataItem, index) => {
			return {
				...dataItem,
				key: `${dataItem.docEntry}-${dataItem.lineId}`,
			}
		})
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchSalesPersonDebtors = async ({ queryKey }) => {
	const [_, startDate, endDate, pageSize, page] = queryKey
	try {
		const url = `api/salesdata/debt-by-managers?startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}
export const fetchPaymentDistribution = async ({ queryKey }) => {
	const [_, startDate, endDate, cashAcct, pageSize, page] = queryKey
	try {
		const url = `api/incomingpayments/payment-distribution?startDate=${startDate}&endDate=${endDate}&cashAcct=${cashAcct}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}
export const fetchSalesPersonKPI = async ({ queryKey }) => {
	const [_, date] = queryKey
	try {
		const url = `api/salesdata/managers-payments?date=${date}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}
export const fetchOrderProfit = async ({ queryKey }) => {
	const [_, pageSize, page, startDate, endDate, department] = queryKey
	try {
		const url = `api/salesdata/profit-by-orders?department=${department}&startDate=${startDate}&endDate=${endDate}&pageSize=${pageSize}&skip=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchSalesBySlp = async ({ queryKey }) => {
	const [_, startDate, endDate, pageSize, page] = queryKey
	try {
		const url = `api/salesdata/sales-by-managers?startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchSalesBySlpSalesRole = async ({ queryKey }) => {
	const [_, startDate, endDate, pageSize, page, slpCode] = queryKey
	try {
		const url = `/api/salesdata/manager-sales?slpCode=${slpCode}&startDate=${startDate}&endDate=${endDate}&skip=${page}&pageSize=${pageSize}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchCheckDebtors = async ({ queryKey }) => {
	const [_, cardCode, phoneNumber] = queryKey
	try {
		const url = `api/businesspartners/get-business-partners-balance?cardCode=${cardCode}&phoneNumber=${phoneNumber}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}


export const fetchGoodIssueReport = async ({ queryKey }) => {
	const [
		_,
		pageSize,
		page,
		startDate,
		endDate,
		department,
		docNum,
		salesOrderDocNum,
		departmentName,
		itemCode,
		itemName,
		master,
		masterName,
		absoluteStatus,
	] = queryKey
	try {
		const url = `api/reports/goods-issue-list?department=${department ?? ''}&startDate=${startDate ?? ''}&endDate=${endDate ?? ''}&pageSize=${pageSize}&skip=${page}&docNum=${docNum ?? ''}&salesOrderDocNum=${salesOrderDocNum ?? ''}&departmentName=${departmentName ?? ''}&itemCode=${itemCode ?? ''}&itemName=${itemName ?? ''}&master=${master ?? ''}&masterName=${masterName ?? ''}&absoluteStatus=${absoluteStatus ?? ''}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchServiceReports = async ({ queryKey }) => {
	const [
		_,
		pageSize,
		page,
		startDataStart,
		startDateEnd	,
		endDateStart,
		endDateEnd,
		endTimeMin,
		endTimeMax,
		warehouse,
		warehouseName,
		service,
		serviceName,
		worker,
		workerName,
		orderNumber,
	] = queryKey
	try {
		const url = `api/reports/services-report?docDateStart=${startDataStart ?? ''}&docDateEnd=${startDateEnd ?? ''}&endDateStart=${endDateStart ?? ''}&endDateEnd=${endDateEnd ?? ''}&endTimeMin=${endTimeMin ?? ''}&endTimeMax=${endTimeMax ?? ''}&warehouse=${warehouse ?? ''}&warehouseName=${warehouseName ?? ''}&service=${service ?? ''}&serviceName=${serviceName ?? ''}&worker=${worker ?? ''}&workerName=${workerName ?? ''}&orderNumber=${orderNumber ?? ''}&pageSize=${pageSize}&skip=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}
export const fetchSalesReportByDepartment = async ({ queryKey }) => {
	const [
		_,
		pageSize,
		page,
		startDate,
		endDate,
		department,
		itemGroup,
		itemName,
		price,
	] = queryKey
	try {
		const url = `api/reports/sales-report-by-department?startDate=${startDate ?? ''}&endDate=${endDate ?? ''}&department=${department ?? ''}&itemGroup=${itemGroup ?? ''}&itemName=${itemName ?? ''}&price=${price ?? ''}&pageSize=${pageSize}&skip=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}
export const fetchMastersTurnoverReport = async ({ queryKey }) => {
	const [_, dateFrom, dateTo, cardCode, cardName] = queryKey
	try {
		const url = `api/reports/masters-turnover-report?dateFrom=${dateFrom ?? ''}&dateTo=${dateTo ?? ''}&cardCode=${cardCode ?? ''}&cardName=${cardName ?? ''}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchMastersReportDetail = async ({ queryKey }) => {
	const [
		_,
		pageSize,
		page,
		dateFrom,
		dateTo,
		cardCode,
		cardName,
		itemCode,
		itemName,
		salesInvoiceDocNum,
		miqdoriMin,
		miqdoriMax,
		lineTotalMin,
		lineTotalMax,
	] = queryKey
	try {
		const url = `api/reports/masters-report-detail?dateFrom=${dateFrom ?? ''}&dateTo=${dateTo ?? ''}&cardCode=${cardCode ?? ''}&cardName=${cardName ?? ''}&itemCode=${itemCode ?? ''}&itemName=${itemName ?? ''}&salesInvoiceDocNum=${salesInvoiceDocNum ?? ''}&miqdoriMin=${miqdoriMin ?? ''}&miqdoriMax=${miqdoriMax ?? ''}&lineTotalMin=${lineTotalMin ?? ''}&lineTotalMax=${lineTotalMax ?? ''}&pageSize=${pageSize}&skip=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchProductionGrossProfitReport = async ({ queryKey }) => {
	const [
		_,
		pageSize,
		page,
		startDate,
		endDate,
		docEntry,
		docNum,
		department,
		departmentName,
		itemCode,
		itemName,
		lineNum,
	] = queryKey
	try {
		const url = `api/reports/production-gross-profit-report?startDate=${startDate ?? ''}&endDate=${endDate ?? ''}&docEntry=${docEntry ?? ''}&docNum=${docNum ?? ''}&department=${department ?? ''}&departmentName=${departmentName ?? ''}&itemCode=${itemCode ?? ''}&itemName=${itemName ?? ''}&lineNum=${lineNum ?? ''}&pageSize=${pageSize}&skip=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}

export const fetchProductionDeliveryReport = async ({ queryKey }) => {
	const [
		_,
		pageSize,
		page,
		startDate,
		endDate,
		docNum,
		department,
		departmentName,
		itemCode,
		itemName,
		warehouse,
	] = queryKey
	try {
		const url = `api/reports/production-delivery-report?startDate=${startDate ?? ''}&endDate=${endDate ?? ''}&docNum=${docNum ?? ''}&department=${department ?? ''}&departmentName=${departmentName ?? ''}&itemCode=${itemCode ?? ''}&itemName=${itemName ?? ''}&warehouse=${warehouse ?? ''}&pageSize=${pageSize}&skip=${page}`
		const { data } = await http.get(url)
		return data
	} catch (error) {
		console.log(error)
	}
}
